import React from "react";
import {
    FORM_1099_BOX_FILTER_UNASSIGNED,
    FORM_1099_BOX_FILTER_UNASSIGNED_LABEL,
    getForm1099BoxLabel,
} from "@common/constants/domains/accounting/form1099Box";
import { AccountingReportFilters } from "../types";

export const Form1099BoxFilterLabel: React.FC<{
    filters: AccountingReportFilters;
}> = ({ filters }) => {
    const labels = (filters.form1099Boxes ?? []).map((box) =>
        box === FORM_1099_BOX_FILTER_UNASSIGNED
            ? FORM_1099_BOX_FILTER_UNASSIGNED_LABEL
            : (getForm1099BoxLabel(box) ?? box),
    );
    return <>{labels.join(", ")}</>;
};
